import React, { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@apollo/client/react';

const GET_BRAND = gql`
  query GetBrand($slug: String!) {
    brandBySlug(slug: $slug) {
      id
      title
    }
  }
`;

type BrandItem = {
  id: string;
  title: string;
};

const Brand = () => {
  const params = useParams();
  const brandSlug = params['*'];
  const [getBrand, { data }] = useLazyQuery<{ brandBySlug: BrandItem }>(
    GET_BRAND,
  );

  useEffect(() => {
    if (brandSlug) {
      getBrand({ variables: { slug: brandSlug } });
    }
  }, [brandSlug]);

  if (data?.brandBySlug) {
    const brandTitle = data.brandBySlug.title;

    const queryParams = new URLSearchParams();
    queryParams.set('brand', brandTitle);

    return (
      <Navigate
        to={{
          pathname: '/tooted',
          search: `?${queryParams.toString()}`,
        }}
      />
    );
  }

  return null;
};

export default Brand;
